export const tabsTheme = {
  transitionDuration: '0.2s',
  tab: {
    padding: 'var(--small-padding)',
    fontWeight: '500',
  },
  tabpanel: {
    padding: 'var(--one-eighth-rem) var(--reset) var(--reset) var(--reset)',
  },
  colorScheme: {
    light: {
      tablist: {
        background: 'var(--transparent)',
        borderColor: 'var(--p-surface-200)',
      },
      tab: {
        color: 'var(--p-surface-500)',
        hoverColor: 'var(--p-primary-500)',
        borderColor: 'var(--transparent)',
        activeColor: 'var(--p-primary-700)',
        activeBorderColor: 'var(--p-primary-700)',
      },
      tabpanel: {
        background: 'var(--transparent)',
        color: 'var(--text-color)',
      },
    },
    dark: {
      tablist: {
        background: 'var(--transparent)',
        borderColor: 'var(--transparent)',
      },
      tab: {
        color: 'var(--p-surface-200)',
        hoverColor: 'var(--p-primary-300)',
        borderColor: 'var(--transparent)',
        activeColor: 'var(--p-primary-400)',
        activeBorderColor: 'var(--p-primary-400)',
      },
      tabpanel: {
        background: 'var(--transparent)',
        color: 'var(--text-color)',
      },
    },
  },
};
